import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IncludeAllDropdownProps {
  allRowsChecked: boolean;
  handleSelectAll: () => void;
  handleClearAll: () => void;
}

const IncludeAllDropdown: React.FC<IncludeAllDropdownProps> = ({ allRowsChecked, handleSelectAll, handleClearAll }) => {
  return (
    <div className="relative">
      <div className="flex items-center gap-2">
        <div className="flex w-auto flex-row items-center justify-center">
          <label className="flex cursor-pointer items-center">
            <input
              type="checkbox"
              className="peer hidden h-4 w-4"
              onChange={(e) => {
                e.target.checked ? handleSelectAll() : handleClearAll();
              }}
              checked={allRowsChecked}
            />
            <div className="bg-buttonSecondary peer-checked:bg-brandSecondary peer-checked:border-brand-secondary-hover flex h-4 w-4 items-center justify-center rounded-full border border-gray-300">
              <FontAwesomeIcon icon={faCheck} className="h-2 w-2 text-white peer-checked:inline-block" />
            </div>
          </label>
        </div>
      </div>
    </div>
  );
};

export default IncludeAllDropdown;
